@switch (type()) {
  @case ('regular') {
    @if (html()) {
      <span
        class="text"
        (mouseenter)="updateShowTooltip()"
        [uTooltip]="showTooltip() ? text() || html() : ''"
        [uTooltipPosition]="uTooltipPosition() || 'above'"
        #textElement
        [uTooltipEscape]="false"
        [innerHtml]="html() | safe: 'html'"
      >
      </span>
    } @else {
      <span
        class="text"
        (mouseenter)="updateShowTooltip()"
        [uTooltip]="showTooltip() ? text() : ''"
        [uTooltipPosition]="uTooltipPosition() || 'above'"
        [class.lines]="lines()"
        [style.-webkit-line-clamp]="lines()"
        #textElement
      >
        {{ text() }}
      </span>
    }
  }
  @case ('file') {
    <span
      class="text-file"
      (mouseenter)="updateShowTooltip()"
      [uTooltip]="showTooltip() ? text() || html() : ''"
      [uTooltipPosition]="uTooltipPosition() || 'above'"
      [uTooltipEscape]="false"
    >
      <span class="text" #textElement> {{ startText() }} </span>
      <span class="end-of-text">{{ endText() }}</span>
    </span>
  }
}
